/**
 * Theme-Hook (Audit AA2).
 * Persistiert Theme-Wahl im localStorage und setzt .theme-light auf <html>.
 *
 * - 'dark' (Default): Cockpit/Bloomberg-Anmutung
 * - 'light': sauberer Fintech-Light-Modus
 *
 * Kein Auto-System-Preference-Match — User wählt explizit.
 */

import { useEffect, useState } from 'react';

export type Theme = 'dark' | 'light';

const STORAGE_KEY = 'cockpit.theme';

function loadTheme(): Theme {
  if (typeof window === 'undefined') return 'dark';
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    // ignore
  }
  return 'dark';
}

function applyTheme(theme: Theme): void {
  if (typeof document === 'undefined') return;
  const html = document.documentElement;
  if (theme === 'light') {
    html.classList.add('theme-light');
  } else {
    html.classList.remove('theme-light');
  }
}

export function useTheme(): {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggle: () => void;
} {
  const [theme, setThemeState] = useState<Theme>(() => loadTheme());

  // Initial-Apply (auch wenn der Hook erst spät gerendert wird)
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = (t: Theme) => {
    setThemeState(t);
    try {
      window.localStorage.setItem(STORAGE_KEY, t);
    } catch {
      // ignore
    }
  };

  const toggle = () => setTheme(theme === 'dark' ? 'light' : 'dark');

  return { theme, setTheme, toggle };
}
